export default "__VITE_ASSET__DPHOP1gQ__"